module.exports = __webpack_public_path__ + "media/application/images/2023/07_still-1250x703-3d1f7585d76daf127067b8eed6148ffb.png";